import { useSaveData } from '@entities/common/savedData/index.ts';
import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { usePromoEditPageRedirect } from '@pages/programs/promo-edit/helpers.ts';
import { PromoForm } from '@widgets/promo-videos';
import { usePromoLoader } from '@features/promo-videos';
import { useScrollToTop } from '@shared/hooks/useScrollToTop';
import { useOneVideoSelect } from '@shared/ui/forms/video/helpers.ts';

export const PromoEdit: React.FC = () => {
  const { doSetStorageData } = useSaveData<number>('promoVideoId');
  const { videoId } = useParams<{ code: string; id: string; videoId: string }>();
  const promoId = Number(videoId);
  const { selectedIds, doResetSelectedIds } = useOneVideoSelect();

  const { doSetStorageData: setPromoVideoId } = useSaveData<number>('promoVideoId');

  const { doRedirectOnPrevPage } = usePromoEditPageRedirect();

  useScrollToTop();
  usePromoLoader(promoId);

  const onClose = () => doRedirectOnPrevPage();

  useEffect(() => {
    if (selectedIds?.length) {
      setPromoVideoId(selectedIds[0]);
      doResetSelectedIds([]);
      onClose();
    }
  }, [selectedIds, setPromoVideoId, doResetSelectedIds]);

  const onSuccess = (videoId: number) => {
    doSetStorageData(videoId);
    onClose();
  };

  return <PromoForm videoId={promoId} onSuccess={onSuccess} onCancel={onClose} />;
};
